<template>
  <div :class="`m-mobile m-mobile-${routeType}-detail ${currentModule}`">
    <!-- 头部导航   <mobile-nav-top></mobile-nav-top> -->
    <!-- 左侧导航  <mobile-nav-left></mobile-nav-left> -->
    <bs-detail :filter="filter" :meta="meta" ref="refId" content-class>
      <template slot="data" slot-scope="slot">
        <!-- <mobile-header :result="slot"></mobile-header> -->
        <mobile-dest-detail-spot :result="slot"></mobile-dest-detail-spot>
      </template>
      <template slot="empty">空数据</template>
    </bs-detail>
  </div>
</template>
<style lange="sass" scoped>
</style>
<script>
export default {
  data() {
    return {
      routeType: "dest",
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        destId: this.$route.params._destId
      },
      api: null
    };
  },
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  mounted() {},
  components: {
    BsDetail: () => import("../../components/bs-detail"),
    MobileDestDetailSpot: () => import("./mobile-dest-detail-spot"),
    MobileHeader: () => import("../../components/mobile/mobile-header"),
    PortalNavTop: () => import("./mobile-nav-top"),
    PortalNavLeft: () => import("./mobile-nav-left"),
    PortalFooter: () => import("./mobile-footer")
  },
  methods: {
    handleGoBack() {}
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  created() {
    this.$menuFn.setTitle("景点");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "mobile-dest-detail") {
        this.$menuFn.setTitle("景点");
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "detail",
        "mobile",
        true
      );
      if (this.routeWatch && contains && this.$route.params._artiId) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.filter.destId = this.$route.params._destId;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>